import apiSlice from "./apiSlice";
const keyClearanceSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeyClearance: builder.mutation({
      query: (body) => ({
        url: `clearance`,
        method: "POST",
        body,
      }),
    }),
    editKeyClearance: builder.mutation({
      query: ({ id, body }) => ({
        url: `/clearance/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteKeyClearance: builder.mutation({
      query: (id, body) => ({
        url: `clearance/${id}`,
        method: "DELETE",
        body,
      }),
    }),
    getPendingIssue: builder.query({
      query: (req) => ({
        url: `issues/pending`,
        params: req,
      }),
    }),
    getSubmittedByMeIssue: builder.query({
      query: (req) => ({
        url: `issues/GetSubmittedIssues`,
        params: req,
      }),
    }),
    approveKeyClearance: builder.mutation({
      query: ({ id }) => ({
        url: `/clearance/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectKeyClearance: builder.mutation({
      query: ({ id, body }) => ({
        url: `/clearance/${id}/reject`,
        method: "POST",
        body,
      }),
    }),
    updateWorkflowClearance: builder.mutation({
      query: (body) => ({
        url: `/Clearance/UpdateWorkFlow`,
        method: "POST",
        body,
      }),
    }),
    getKeyClearance: builder.query({
      query: (req) => ({
        url: `Clearance/${req}`,
      }),
    }),
  }),
});

export const {
  useAddKeyClearanceMutation,
  useEditKeyClearanceMutation,
  useDeleteKeyClearanceMutation,
  useGetPendingIssueQuery,
  useGetSubmittedByMeIssueQuery,
  useApproveKeyClearanceMutation,
  useRejectKeyClearanceMutation,
  useGetKeyClearanceQuery,
  useUpdateWorkflowClearanceMutation
} = keyClearanceSlice;
